import React from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import ContactRows from './ContactRows';
import classNames from 'classnames';

import './styles/ContactList.scss';

/* Standard way to creates a table for a list of contacts (or anything else with an id) based on column definitions */
const ContactList = ({
  className,
  rowClassName,
  columns,
  contacts,
  emptyMessage,
  onSort,
  sort,
  makeRow,
  getSubRowContacts,
  makeSubRows,
  superHeader,
  makeSubTable,
  subTableColumnSpan
}) => {
  if (contacts.error && contacts.errorMessage) {
    return (
      <div className='alert alert-danger'>
        {contacts.errorMessage}
      </div>
    );
  }

  return (
    <div className='scrollable-list'>
      <table className={classNames('contact-list-react', className)}>
        {columns.length > 0 && <Header columns={columns} onSort={onSort} sort={sort} superHeader={superHeader} />}
        <ContactRows
          rowClassName={rowClassName}
          columns={columns}
          contacts={contacts}
          emptyMessage={emptyMessage}
          makeRow={makeRow}
          getSubRowContacts={getSubRowContacts}
          makeSubRows={makeSubRows}
          makeSubTable={makeSubTable}
          subTableColumnSpan={subTableColumnSpan}
        />
      </table>
    </div>
  );
};

ContactList.propTypes = {
  /** Class name(s) to add to the table (optional) */
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

  /** Function that returns contents for a potential extra header row above the normal one */
  superHeader: PropTypes.func,

  /** Metadata about the columns in this contact list */
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string
    ]),
    value: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.number
    ]),
    subRowValue: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.string,
      PropTypes.number
    ]),
    sortName: PropTypes.string,
    type: PropTypes.string,
    fontAwesomeIcon: PropTypes.string
  })),

  /** The list of contacts can be object with a pending state */
  contacts: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.shape({})
  ]),

  /** The message to show if there are no contacts */
  emptyMessage: PropTypes.string,

  /** A function that is called on a column's sortName on click */
  onSort: PropTypes.func,

  /** The selected sort */
  sort: PropTypes.shape({
    column: PropTypes.string,
    order: PropTypes.string
  }),

  /** Optional function to display custom row.  Defaults to regular ContactRow */
  makeRow: PropTypes.func,

  /** Optional function that takes a "contact" and returns a list of "contacts" to apply subRowValue/value to to create
   * sub-rows. Use either this or makeSubRows for sub-rows */
  getSubRowContacts: PropTypes.func,

  /** Optional function that takes a "contact" and columns and manually creates the rows that appear when a ContactRow
   * is expanded. Use either this or getSubRowContacts for sub-rows */
  makeSubRows: PropTypes.func,

  /** generate sub_table fo the row  */
  makeSubTable: PropTypes.func,

  /** Optional number to indicate how many columns are spanned using `colSpan` for the nested table */
  subTableColumnSpan: PropTypes.number
};


ContactList.defaultProps = {
  columns: [],
  contacts: [],
  emptyMessage: undefined,
  onSort: () => false,
  sort: {},
  makeRow: undefined,
  getSubRowContacts: undefined,
  makeSubRows: undefined,
  makeSubTable: undefined,
  subTableColumnSpan: undefined
};

export default ContactList;
